import React, { useState, useEffect } from "react";
import * as moment from "moment";

import "./FlexPackage.css";
import { Util } from "../../../../../../../helpers/util";
import { $api } from "../../../../../../../helpers/$api";

const FlexibleEarnings = ({ plan_id }) => {
  const { currency } = Util.getCurrency();
  const [earnings, setEarnings] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const earnings = await $api.savest.getSavestEarnings(plan_id);

        setEarnings(earnings);
      } catch (error) {
        // error getting earnings...
      }
    })();
  }, [setEarnings, plan_id]);

  return (
    <div>
      <div className="earning-body">
        <div className="myinvestment-main">
          <div className="earning-flex">
            <h5 className="earning-headertag">Earning Details</h5>
          </div>
          <p className="earning-p">View your investment earnings transaction</p>
          <div className="dateandearning mt-5">
            {earnings.map((earning) => {
              return (
                <>
                  <div className="earning-flex">
                    <p className="date-p">Date</p>
                    <p className="date-p">Earnings</p>
                  </div>
                  <div className="earning-flex">
                    <p className="price-p">
                      {moment(earning.created_at).format("DD MMM, YYYY")}
                    </p>
                    <p className="price-p">
                      {currency} {Util.formatMoneyNumber(earning.roi)}
                    </p>
                  </div>
                  <hr />
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlexibleEarnings;
